module.exports = __webpack_public_path__ + "img/heavy_machinery.f689f9d4.svg";